const pesIconSizes = {
  NANO: 'nano',
  MICRO: 'micro',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge',
};
const pesIconMirrorDirection = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
  BOTH: 'both',
};
const LOAD_TIMEOUT = 10000;
const ICON_FONT_NAME = 'se-icon';

export { ICON_FONT_NAME as I, LOAD_TIMEOUT as L, pesIconMirrorDirection as a, pesIconSizes as p };
